const state = {
  checkedData: {}
};

const getters = {
  getIsSummaryPageOptionActive: (state, getters) => {
    return getters.getConfig.selected_page_option_summary
      ? parseInt(getters.getConfig.selected_page_option_summary)
      : 0;
  },
  getIsCheckedPageOptionActive: (state, getters) => {
    return getters.getConfig.checked_page_option
      ? parseInt(getters.getConfig.checked_page_option)
      : 0;
  },
  getIsShowCheckedPageOptionFlag: state => {
    return false;
  },
  getChecked: (state, getters) => po_index => {
    return state.checkedData[getters.getActiveProductPartCode][po_index]
      .checked;
  },
  getCheckedInPP: state => payload => {
    for (
      var counter = 0;
      counter < Object.keys(state.checkedData[payload.pp]).length;
      counter++
    ) {
      if (state.checkedData[payload.pp][counter].code == payload.po_name) {
        return state.checkedData[payload.pp][counter].checked;
      }
    }

    return true;
  },
  getCheckedIsNext: (state, getters) => po_index => {
    if (po_index == 0) {
      return true;
    }
    for (var i = 0; i < po_index; i++) {
      if (!state.checkedData[getters.getActiveProductPartCode][i].checked) {
        return false;
      }
    }
    return true;
  },
  getIndexProdPartItems: state => pp => {
    var previous = 0;
    for (var i = 0; i < Object.keys(state.checkedData).length; i++) {
      var ppKey = Object.keys(state.checkedData)[i];
      if (ppKey == pp) {
        return previous;
      }
      previous += Object.keys(state.checkedData[ppKey]).length;
    }

    return 0;
  },
  getPPCanBeSelected: state => pp => {
    for (var i = 0; i < Object.keys(state.checkedData).length; i++) {
      var ppKey = Object.keys(state.checkedData)[i];
      if (ppKey == pp) {
        return true;
      }
      for (var j in state.checkedData[ppKey]) {
        if (!state.checkedData[ppKey][j].checked) {
          return false;
        }
      }
    }

    return false;
  }
};

const mutations = {
  setCheckedPOData: (state, payload) => {
    var data = {};
    for (const objIdx in payload) {
      const obj = payload[objIdx];
      var allPageOptions = obj.page_options;
      var options = Object.keys(allPageOptions)
        .filter(item => {
          return allPageOptions[item].hidden == 0;
        })
        .reduce((obj, key, index) => {
          obj[index] = { checked: false, code: key };
          return obj;
        }, {});

      data[obj.code] = options;
    }
    state.checkedData = data;
  },
  setCheckedPOItem: (state, payload) => {
    var data = {
      ...state.checkedData
    };
    data[payload.pp][payload.po_index].checked = true;
    for (
      var i = payload.po_index + 1;
      i < Object.keys(data[payload.pp]).length;
      i++
    ) {
      data[payload.pp][i].checked = false;
    }

    var setNotChecked = false;
    for (var i = 0; i < Object.keys(state.checkedData).length; i++) {
      var ppKey = Object.keys(state.checkedData)[i];
      if (ppKey == payload.pp) {
        setNotChecked = true;
        continue;
      }
      if (!setNotChecked) {
        continue;
      }
      for (var j in state.checkedData[ppKey]) {
        state.checkedData[ppKey][j].checked = false;
      }
    }

    state.checkedData = data;
  }
};

const actions = {
  setCheckedPOData: ({ commit, getters }, payload) => {
    if (
      getters.getIsCheckedPageOptionActive ||
      getters.getIsSummaryPageOptionActive
    ) {
      commit("setCheckedPOData", payload);
    }
  },
  setCheckedPOItem: ({ commit, getters }, payload) => {
    if (
      getters.getIsCheckedPageOptionActive ||
      getters.getIsSummaryPageOptionActive
    ) {
      commit("setCheckedPOItem", payload);
    }
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
